import { Button, Card, CardContent, Grid, Container, Stepper, Step, StepLabel } from '@mui/material'
import { ArrowLeft, ArrowLeftCircle, Save } from 'react-feather'

import { DefaultFinishStep } from './DefaultFinishStep'
import {ContractFormStepApplies} from './StepApplication/MgmtStepApplication'
import {ContractFormStepFiles} from './StepFiles/MgmtStepFiles'
import {ContractFormStepDeposit} from './StepDeposit/MgmtStepDeposit'
import {ContractFormStepApproval} from './StepApproval/MgmtStepApproval'
import { ObservationLog } from './ObservationLog'

// Array que define cuantos pasos va a tener
const steps = ['Info. Solicitud', 'Documentos Adjuntos', 'Depositos', 'Info. Aprobación']

const ContractAppliesForm = ({useFetchInit}) => {
    
    const {
        globalStates,
        Forms,
        Actions
    } = useFetchInit

    const { FormLeases } = Forms
    const { formState } = FormLeases

    const { stepApplilication } = globalStates

    const { handleClickCompleteRequest, handleClickHideForm, handleClickReturnStep } = Actions

    // Para definir que va a renderizar en cada paso
    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <ContractFormStepApplies
                    useFetchInit = {useFetchInit}
                />
            case 1:
                return <ContractFormStepFiles 
                    useFetchInit = {useFetchInit}
                />;
            case 2:
                return <ContractFormStepDeposit
                    useFetchInit = {useFetchInit}
                />;
            case 3:
                return <ContractFormStepApproval
                    useFetchInit = {useFetchInit}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <Button
                            startIcon={<ArrowLeft/>}
                            variant='text'
                            color='error'
                            size='large'
                            sx={{ marginTop: 2, marginBottom : 2 }}
                            onClick={handleClickHideForm}
                        >
                            Volver a la pantalla anterior
                        </Button>
                        <div className="border-bottom border-dark"></div>

                        <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                            <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Container>
                        
                        <p className='text-danger'>* campos obligatorios</p>
                        {stepApplilication === steps.length ? (
                            <DefaultFinishStep
                                handleClickReturnStep={handleClickReturnStep}
                                handleClickCompleteRequest={handleClickCompleteRequest}
                            />

                        ) : (
                            <>
                                {getStepContent(stepApplilication)}
                                {(formState.idcontrato>0)&&(
                                    <ObservationLog useFetchInit={useFetchInit}></ObservationLog>
                                )}
                            </>
                        )}
                    </CardContent>
                </Card>
            </Grid> 
        </Grid>
    )
    
}

export {
    ContractAppliesForm
}